module.exports = {
  Bug: {
    color: '#A6B91A'
  },     
  Dark: {
    color: '#705746'
  },    
  Dragon: {
    color: '#6F35FC'
  },  
  Electric: {
    color: '#F7D02C'
  },
  Fairy: {
    color: '#D685AD'
  },   
  Fighting: {
    color: '#C22E28'
  },
  Fire: {
    color: '#EE8130'
  },    
  Flying: {
    color: '#A98FF3'
  },  
  Ghost: {
    color: '#735797'
  },   
  Grass: {
    color: '#7AC74C'
  },   
  Ground: {
    color: '#E2BF65'
  },  
  Ice: {
    color: '#96D9D6'
  },     
  Normal: {
    color: '#A8A77A'
  },  
  Poison: {
    color: '#A33EA1'
  },  
  Psychic: {
    color: '#F95587'
  }, 
  Rock: {
    color: '#B6A136'
  },    
  Steel: {
    color: '#B7B7CE'
  },   
  Water: {
    color: '#6390F0'
  }
};



// WEBPACK FOOTER //
// ./src/utils/poketypes.js